exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".starter-page {\n  min-height: calc(100vh - 380px);\n}\n.page-landing .gantt_layout .gantt_side_content a:link {\n  cursor: not-allowed;\n}", "", {"version":3,"sources":["/var/www/html/brkt/src/app/pages/GuestHome.vue"],"names":[],"mappings":"AACA;EACE,gCAAA;CAAF;AAKM;EACE,oBAAA;CAFR","file":"GuestHome.vue?vue&type=style&index=0&id=041e48f5&lang=scss","sourcesContent":["\n.starter-page {\n  min-height: calc(100vh - 380px);\n}\n.page-landing {\n  .gantt_layout {\n    .gantt_side_content {\n      a:link {\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
